export default class OmniHelper {
  static isRestrictedChannel(data) {
    if (!data) {
      return false;
    }
    let RESTRICTED_CHANNELS = ['app_store', 'play_store'];
    return RESTRICTED_CHANNELS.includes(data.channel);
  }
}
